export default {"src":"/_next/static/media/atm-logo-white.f2b7f9f3.svg","height":54,"width":91,"blurWidth":0,"blurHeight":0};